import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TAdminAssetsListReqParams,
  TAssetsListReqParams,
  TAssetsListResData,
  TCreateAssetReqParams,
  TCreateAssetResData,
} from '../types/assets.types';

export const createAsset = async (
  counterpartyGuid: string,
  params: TCreateAssetReqParams,
): Promise<TCreateAssetResData> => {
  const url = API_ENDPOINTS.ASSETS.COUNTERPARTY_ASSETS.replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const res = await apiClient.post<TCreateAssetResData>(url, params);

  return res.data;
};

export const getAssetsListService = async (
  counterpartyGuid: string,
  params: TAssetsListReqParams = {},
): Promise<TAssetsListResData> => {
  const url = API_ENDPOINTS.ASSETS.COUNTERPARTY_ASSETS.replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const config = {
    params,
  };
  const res = await apiClient.get<TAssetsListResData>(url, config);

  return res.data;
};

export const getAssetsListAdminService = async (params?: TAdminAssetsListReqParams): Promise<TAssetsListResData> => {
  const url = API_ENDPOINTS.ASSETS.ASSETS;
  const config = {
    params,
  };
  const res = await apiClient.get<TAssetsListResData>(url, config);

  return res.data;
};
